var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "modal__feature-vendor-doc",
      attrs: { href: _vm.decode(_vm.doc.downloadURL) }
    },
    [
      _c("div", { staticClass: "h-display-inline" }, [
        _c("div", { staticClass: "modal__vendor-doc-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal__vendor-doc-download h-display-inline-block"
            },
            [_vm._v(_vm._s(_vm.doc.title))]
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "modal__vendor-doc-description h-display-block",
          domProps: { innerHTML: _vm._s(_vm.doc.description) }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "modal__vendor-doc-icon h-display-inline-block" },
      [_c("i", { staticClass: "far fa-file" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }